import styled from 'styled-components';
import { heading, text } from '@carvana/helios-styles';
import breakpoint from '@carvana/helios-layout/breakpoint';

export const GetValueContainer = styled.section`
  background: linear-gradient(
      105.84deg,
      rgba(150, 245, 182, 0.25) -18.7%,
      rgba(150, 245, 182, 0.5) 4.17%,
      rgba(150, 245, 182, 0) 39.46%
    ),
    linear-gradient(
      225.81deg,
      #ffd43b -8.12%,
      rgba(150, 245, 182, 0.15) 39.86%,
      rgba(150, 245, 182, 0) 58.51%
    ),
    linear-gradient(0deg, #228be6, #228be6),
    linear-gradient(108.04deg, #106bc7 0%, #228be6 49.59%, #3bc9db 100%);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 24px;
  margin: 32px 0 56px 0;
  ${breakpoint.sm`
    padding: 56px 24px;
    margin: 40px 0 64px 0;
  `};
  ${breakpoint.xl`
    margin: 56px 0 120px 0;
  `}
`;

export const Heading = styled.h2`
  ${heading.xl};
  color: ${text.inverse};
  padding-bottom: 40px;
  text-align: center;
  ${breakpoint.sm`
    ${heading['3Xl']}
  `}
`;
